import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { PanierState } from '../models';
import { HttpServices } from '../services/http.service';
import { LoaderService } from '../services/loader.service';
import { PanierService } from '../services/panier.service';
import * as config from '../config/config';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TrackingService } from '../services/tracking.service';

@Component({
  selector: 'fs-payment-iframe',
  templateUrl: './payment-iframe.component.html',
  styleUrls: ['./payment-iframe.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentIframeComponent implements OnInit, OnDestroy {
  iframeUrl;
  supplierId;
  amount;
  canLeave = false;
  isClickSendOgone = false;
  iframeLoaded = false;
  faChevronLeft = faChevronLeft;
  orderId;
  targetPage = '/balance-outstanding';
  targetPageSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    private loaderService: LoaderService,
    private panierService: PanierService,
    private router: Router,
    public ngxSmartModalService: NgxSmartModalService,
    private httpServices: HttpServices,
    private trackingService: TrackingService
  ) {
    this.targetPageSubscription = router.events.pipe(
      filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => this.targetPage = event.url);
  }

  ngOnInit() {
    this.loaderService.increaseLoaderCount();
    this.supplierId = this.activatedRoute.snapshot.queryParamMap.get('supplierId');
    this.amount = this.activatedRoute.snapshot.queryParamMap.get('amount');
    this.orderId = this.activatedRoute.snapshot.queryParamMap.get('orderId');
    this.iframeUrl = this.activatedRoute.snapshot.queryParamMap.get('iframeUrl');
    this.iframeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);

    setTimeout(() => {
      if (!this.iframeLoaded) {
        this.iframeLoaded = true;
        this.canLeave = false;
        this.loaderService.decreaseLoaderCount();
      }
    }, 5000);
  }

  canDeactivate(): boolean {
    if (!this.canLeave) {
      this.ngxSmartModalService.open('paymentIframeExitModal');
    }
    return this.canLeave;
  }

  onIframeLoad(): void {
    if (this.iframeLoaded && this.panierService.getCartState() === PanierState.PAY_IN_PROGRESS) {
      this.canLeave = false;
      this.loaderService.decreaseLoaderCount();
    }
  }

  onPaymentExitConfirmed(): void {
    this.loaderService.increaseLoaderCount();
    if (!this.isClickSendOgone) {
      this.httpServices.put<any, any>(
        config.ApiKeys.PUT_CANCEL_PAYEMENT,
        '',
        () => { },
        [{ 'Key': 'idFournisseur', 'Value': this.supplierId },
        { 'Key': 'orderId', 'Value': this.orderId }]
      ).subscribe(() => this.exitPageProcess());
    } else {
      this.exitPageProcess();
    }
  }

  private exitPageProcess(): void {
    this.ngxSmartModalService.close('paymentIframeExitModal');
    this.canLeave = true;
    this.router.navigate([this.targetPage]);
    this.loaderService.decreaseLoaderCount();
  }

  @HostListener('window:message', ['$event'])
  returnInfoPayment(event: any): void {
    switch (event.data.event_id) {
      case 'ready': {
        this.iframeLoaded = true;
        this.canLeave = false;
        this.trackingService.pushEvent('financial-online_payment-step3');
        this.loaderService.decreaseLoaderCount();
        break;
      }
      case 'cliksendogone': {
        this.isClickSendOgone = true;
        this.loaderService.increaseLoaderCount();
        break;
      }
      case 'redirect': {
        if (event.data.status === 'accept') {
          this.panierService.setCartState(PanierState.PAY_SUCCESS);
          this.trackingService.pushEvent('financial-online_payment-confirmation');
        } else if (event.data.status === 'exception' || event.data.status === 'fault' || event.data.status === 'cancel') {
          this.panierService.setCartState(PanierState.PAY_ERROR);
          this.trackingService.pushEvent('financial-online_payment-failure');
        }
        this.canLeave = true;
        this.router.navigate(['/balance-outstanding'], { queryParams: { paymentSupplierId: this.supplierId } });
        this.loaderService.decreaseLoaderCount();
        break;
      }
      case 'error': {
        this.loaderService.decreaseLoaderCount();
        break;
      }
      default:
        break;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    event.returnValue = ' ';
    return ' ';
  }

  ngOnDestroy() {
    this.targetPageSubscription.unsubscribe();
  }
}
